import { lazy, Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useGlobalContext } from '../../context/globalContext';
import { useIdentificationStepsContext } from '../../context/Identification';
import Steps from '../../shared/steps/steps';
import Loader from '../../shared/loaders/simpleLoader';
import useServiceType from '../../hooks/useServiseType';
import { SERVICE_TYPES } from '../../utils/constants/fieldErrors';

const Agreement = lazy(() =>
    import('../../components/Identification/steps/agreement')
);
const Step2 = lazy(() => import('../../components/Identification/steps/step2'));
const Step3 = lazy(() => import('../../components/Identification/steps/step3'));
const Step4 = lazy(() => import('../../components/Identification/steps/step4'));

export function IdentificationStepRoutes() {
    const { steps, activeStep, setActiveStep } =
        useIdentificationStepsContext();
    const { i18n } = useTranslation();
    const { serviceType } = useServiceType();
    const {
        globalData: { status },
    } = useGlobalContext();

    const isApproved = useMemo(() => status !== 'Approved', [status]);

    return (
        <Steps
            steps={steps}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            hideSteps={serviceType !== SERVICE_TYPES.identification && true}
        >
            <Suspense fallback={<Loader />}>
                {isApproved ? (
                    <Switch>
                        <Route
                            component={Agreement}
                            path={`/identification/agreement/:mobile?/${i18n.language}/:userId?`}
                        />
                        <Route
                            component={Step2}
                            path={`/identification/Identomat/${i18n.language}`}
                        />
                        <Redirect
                            to={`/identification/agreement/${i18n.language}/:userId?`}
                        />
                    </Switch>
                ) : (
                    <Switch>
                        <Route
                            component={Step3}
                            path={`/identification/step/3`}
                        />
                        <Route
                            component={Step4}
                            path={`/identification/step/4`}
                        />
                        <Redirect to={`/identification/step/3`} />
                    </Switch>
                )}
            </Suspense>
        </Steps>
    );
}
